/**
 * @generated SignedSource<<b1d4f704f0e77985978d0f01873969f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SuppressTaskOutsideProjectPeriodWarningInput = {
  projectId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type suppressTaskOutsideProjectPeriodWarningMutation$variables = {
  input: SuppressTaskOutsideProjectPeriodWarningInput;
};
export type suppressTaskOutsideProjectPeriodWarningMutation$data = {
  readonly suppressTaskOutsideProjectPeriodWarning: {
    readonly viewer: {
      readonly id: string;
    } | null;
  } | null;
};
export type suppressTaskOutsideProjectPeriodWarningMutation = {
  variables: suppressTaskOutsideProjectPeriodWarningMutation$variables;
  response: suppressTaskOutsideProjectPeriodWarningMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuppressTaskOutsideProjectPeriodWarningPayload",
    "kind": "LinkedField",
    "name": "suppressTaskOutsideProjectPeriodWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "suppressTaskOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "suppressTaskOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e2ee9ee0373595eb52b833235df47aa3",
    "id": null,
    "metadata": {},
    "name": "suppressTaskOutsideProjectPeriodWarningMutation",
    "operationKind": "mutation",
    "text": "mutation suppressTaskOutsideProjectPeriodWarningMutation(\n  $input: SuppressTaskOutsideProjectPeriodWarningInput!\n) {\n  suppressTaskOutsideProjectPeriodWarning(input: $input) {\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c417f55025459d0fdb296cbd76264d39";

export default node;
